module.exports = __webpack_public_path__ + "img/kinesis-logo-white.1a686d3e.svg";